import footerBg from "../../../images/footer-bg.jpg";
import socialIcons from "../../../images/social-icons.png";

export const styles = {
  container: {
    fontFamily: "Raleway",
    padding: "40px 0 40px",
    background: `url(${footerBg}) top center no-repeat #0a3949`,
    color: "#8290a2",
    zIndex: 100,
    position: "relative",
  },
  slogan: {
    color: "#27a338",
  },
  green: {
    margin: "0 0 10px",
    padding: 0,
    color: "#39b54a",
    fontSize: 18,
    fontWeight: 600,
  },
  input: {
    height: 47,
  },
  p: {
    fontSize: 14,
    color: "#8290a2",
    lineHeight: 1.6,
  },
  socialSprite: {
    width: 38,
    height: 38,
    float: "left",
    margin: "0 11px",
    background: `url(${socialIcons}) 0 0 no-repeat`,
  },
  google: {
    background: `url(${socialIcons}) 0 0 no-repeat`,
  },
  twitter: {
    background: `url(${socialIcons}) -41px 0 no-repeat`,
  },
  facebook: {
    background: `url(${socialIcons}) -82px 0 no-repeat`,
  },
  rss: {
    background: `url(${socialIcons}) -124px 0 no-repeat`,
  },
  hr: {
    margin: "60px 0 45px",
    backgroundColor: "#8290a2",
    height: 1,
  },
  h2: {
    marginBottom: 20,
  },
};
